const ActionTypes = {
  GET_RESOURCE_POKEMON: "GET_RESOURCE_POKEMON",
  GET_POKEMONS: "GET_POKEMONS",
  FOUND_POKEMON: "FOUND_POKEMON",
  GET_POKEMONS_FAIL: "GET_POKEMONS_FAIL",
  POKEMON_NOT_FOUND: "POKEMON_NOT_FOUND",
  START_SEARCH_ACTION: "START_SEARCH_ACTION",
  END_SEARCH_ACTION: "END_SEARCH_ACTION",
  ADD_TO_SEARCH_HISTORY: "ADD_TO_SEARCH_HISTORY",
  GET_POKEMON_DETAILS: "GET_POKEMON_DETAILS",
  GET_EVOLS_CHAIN: "GET_EVOLS_CHAIN",
  GET_MOVES_INFO: "GET_MOVES_INFO",
  MOVES_LOADING: "MOVES_LOADING",
  GET_POKEMON_TYPES: "GET_POKEMON_TYPES",
  GET_ENCOUNTER_DETAILS: "GET_ENCOUNTER_DETAILS",
};

export default ActionTypes;
